import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FetchSelect from '../../../../core/form/FetchSelect';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Button from '../../../../core/form/Button';
import Select from '../../../../core/form/Select';
import RangeDateInput from '../../../../core/form/RangeDateInput';
import moment from 'moment';

const UnitAverageExecutionTimeListFilter = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2.5}>
        <RangeDateInput
          required
          label="Period"
          disabled={props.fetching}
          onChange={([from, to]) => {
            props.onChange('from', from);
            props.onChange('to', to);
          }}
          onCalendarChange={([from, to]) => {
            props.onChange('from', from);
            props.onChange('to', to);
          }}
          disabledDate={(current) => {
            return current.isAfter(moment()) || Math.abs(moment().diff(current, 'days')) > 90;
          }}
          placeholder={['From', 'To']}
          value={[get(props.values, 'from', undefined), get(props.values, 'to', undefined)]}
          errorText={get(props.errors, 'from', '')}
        />
      </Column>
      <Column size={2}>
        <FetchSelect
          required
          url="/courses"
          label="Select the course"
          disabled={props.fetching}
          value={get(props.values, 'course')}
          onChange={(value) => {
            props.onChange('course', value);
            props.onChange('module', null);
          }}
          sortCondition={['order']}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
          errorText={get(props.errors, 'course', '')}
        />
      </Column>
      <Column size={4}>
        <FetchSelect
          showSearch
          required
          label="Filter by module"
          placeholder="Select the course to allow select the  module"
          url={props.values.course && `/modules?query[course]=${get(props.values, 'course', '')}`}
          disabled={props.fetching || !props.values.course}
          value={get(props.values, 'module')}
          onChange={(value) => {
            props.onChange('module', value);
          }}
          sortCondition={['group', 'order']}
          resultTransformer={{
            text: 'name',
            value: 'id',
            textFunc: (row) => `${row.group} - ${row.order} - ${row.name}`,
          }}
          errorText={get(props.errors, 'module', '')}
        />
      </Column>
      <Column size={2}>
        <Select
          label="Filter Unit group"
          value={get(props.values, 'unitGroup', '')}
          onChange={(value) => props.onChange('unitGroup', value)}
          disabled={props.fetching || !props.values.course}
          options={[
            {
              label: 'A',
              value: 'A',
            },
            {
              label: 'B',
              value: 'B',
            },
            {
              label: 'C',
              value: 'C',
            },
            {
              label: 'D',
              value: 'D',
            },
          ]}
        />
      </Column>
      <Column size={1.5}>
        <div style={{ height: 42 }} />
        <Button disabled={props.fetching} icon="search" buttonType="submit" label="Search" />
      </Column>
    </Row>
  </form>
);

UnitAverageExecutionTimeListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
};

UnitAverageExecutionTimeListFilter.defaultProps = {
  fetching: false,
};

export default UnitAverageExecutionTimeListFilter;
